import { IconComponent } from "@/types/common";
import {
  FolderSimpleIcon,
  LockIcon,
  StarIcon,
  CheckCircleIcon,
  SlidersIcon,
  LightningIcon,
} from "@phosphor-icons/react";

const FEATURES = [
  {
    icon: StarIcon,
    title: "Quick Capture",
    description: "Instantly capture your thoughts and ideas",
  },
  {
    icon: FolderSimpleIcon,
    title: "Smart Organization",
    description: "Organize with folders and tags",
  },
  {
    icon: LockIcon,
    title: "Secure & Private",
    description: "Your notes are encrypted and protected",
  },
  {
    icon: CheckCircleIcon,
    title: "Todos",
    description: "Manage and track your tasks effortlessly",
  },
  {
    icon: LightningIcon,
    title: "No Loading Times",
    description: "Instant access to your notes with zero delays",
  },
  {
    icon: SlidersIcon,
    title: "Customizable Editor Toolbar",
    description: "Tailor the editor to your workflow",
  },
];

export function WelcomeStep() {
  return (
    <div className="flex w-full flex-col gap-6">
      <p className="text-xl font-semibold">Key Features</p>

      {FEATURES.map((feature) => (
        <FeatureItem key={feature.title} icon={feature.icon} title={feature.title} description={feature.description} />
      ))}
    </div>
  );
}

function FeatureItem({ icon: Icon, title, description }: { icon: IconComponent; title: string; description: string }) {
  return (
    <div className="flex items-center gap-3">
      <Icon className="text-xl" weight="duotone" />
      <div>
        <p className="font-medium">{title}</p>
        <p className="text-foreground-600 text-sm">{description}</p>
      </div>
    </div>
  );
}
